import styled, { css } from 'styled-components';

const View = styled.div`
  display: flex;
  flex-direction: column;
  ${(props) =>
    props.horizontal &&
    css`
      flex-direction: row;
    `}
  text-align: ${(props) => props.textAlign};
  align-items: ${(props) => props.alignItems};
  justify-content: ${(props) => props.justifyContent};
`;

export default View;
